import top from './en/top'

const lang = {
	top,
}

export default lang;